import React from 'react';
import { FormFieldsData, useShowContext } from 'ui-builder';
import { TaskType } from 'nekst-api';

import styles from './IsAutoSentField.module.scss';

export interface IsAutoSentFieldProps {
  source: string
}

export default function IsAutoSentField(props: IsAutoSentFieldProps) {
  const context = useShowContext<FormFieldsData>();

  if (context?.data) {
    const taskType = context.data.type as TaskType;
    const value = context.data[props.source] as boolean;

    // Only show for Email and SMS tasks
    if (value && (taskType === TaskType.EMAIL || taskType === TaskType.SMS)) {
      return (
        <i className={styles.icon} title="Auto-Sent Task">
          &nbsp;
        </i>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}
